import { el, mount, unmount, setChildren } from 'redom';

import SimpleDialogNative from 'generics/components/simple-dialog/native';

import FilterEditorPanel from 'root/startup-view/reused/filter-panel';
import FieldSelector from 'root/startup-view/reused/filter-panel/data-collection-field-selector';

class FilterEditor {

  constructor(configuration) {

    this.filterEditorPanel = null;
    this.dialog = null;
    this.collection = null;
    this.application = configuration.application;
    this.mode = configuration.mode;
    this.collectionId = configuration.collectionId;
    this.filter = configuration.filter || null;
    this.saveFilter = configuration.saveFilter;
    this.onSave = configuration.onSave;
    this.onDelete = configuration.onDelete;

    this.el = el('.data-collection-filter-editor-main', [
      el('ht-spinner')
    ]);

  }

  mountPanel() {

    const scrollableParentId = 'helptap-body';
    const filterEditorPanel = new FilterEditorPanel({
      customerFilter: {
        ...this.filter,
        value: this.filter.criteria
      },
      scrollableParentId,
      onSave: this.onSave,
      onClose: this.hide.bind(this),
      disableDelete: true,
      fieldSelector: new FieldSelector({
        collectionId: this.collection._id,
        columns: this.collection.columns
      }),
      saveFilter: this.saveFilter,
    });
    filterEditorPanel.initialize();

    setChildren(this.el, [filterEditorPanel]);

  }

  async initialize() {

    let promises = [];

    if (this.mode === FilterEditor.modes.CREATE) {
      promises.push(this.application.dataManagers.get('DataCollectionFiltersManager').create(this.collectionId));
    } else {
      promises.push(Promise.resolve(this.filter));
    }
    promises.push(this.application.serverInterface.startup.dataCollections.getPopulatedCollectionById(this.collectionId));

    const [filter, collection] = await Promise.all(promises);

    this.filter = { ...filter };
    this.collection = collection;

    this.mountPanel();

  }

  onmount() {

    this.initialize();

  }

  getDynamicElementsContainer() {

    return document.getElementById('root-level-dynamic-elements-container');

  }

  show() {

    const mountPoint = this.getDynamicElementsContainer();

    const scrollableParentId = 'helptap-body';
    const dialogOptions = {
      contentContainerId: scrollableParentId,
      contentHolderClassName: 'data-collection-filter-editor-panel',
      content: this.el,
      onClose: this.hide.bind(this)
    };
    this.dialog = new SimpleDialogNative(dialogOptions);

    mount(mountPoint, this.dialog);
    this.initialize();

  }

  hide(event) {
    console.log({ event });
    const mountPoint = this.getDynamicElementsContainer();

    unmount(mountPoint, this.dialog);

    this.dialog = null;

  }

}

FilterEditor.modes = {
  CREATE: 'CREATE',
  EDIT: 'EDIT'
};

export default FilterEditor;